export const priceValidation = value => {
  if (isNaN(Number(value))) {
    return 'Value must be a number';
  } else if (Number(value) <= 0) {
    return 'Value must be more than 0';
  } else if (!isNaN(Number(value))) {
    if (!Number.isInteger(Number(value)) && String(value).split('.').pop().length > 2) {
      return 'More than 2 digits after point';
    }
    if (String(value).length > 11) {
      return 'Ensure that there are no more than 10 digits in total';
    }
    if (String(Math.round(String(Math.abs(value)))).length > 8) {
      return 'No more than 8 digits before decimal point';
    }
  }
  return null;
};
